import { render } from "./editVariant.vue?vue&type=template&id=56fb111c"
import script from "./editVariant.vue?vue&type=script&lang=js"
export * from "./editVariant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__